export enum Theme {
  THEME_LIGHT_FLYADEAL = 'theme-light-flyadeal',
  THEME_LIGHT_FRONTIER = 'theme-light-frontier',
  THEME_LIGHT_HTS = 'theme-light-hts',
  THEME_LIGHT_JAZEERA = 'theme-light-jazeera',
  THEME_LIGHT_VOLARIS = 'theme-light-volaris',
}
